import profileQuery from '../queries/profile';
import mediaHelper from '../../../helpers/request/media';
import { SET_USER_PHOTO, CLEAR_USER_PHOTO } from './types';

export const updateProfile = ({ rootState, dispatch }, profile) => {
  const currentUserInfo = rootState.index.userInfo;
  const updatedProfile = Object.assign({}, currentUserInfo, profile);
  return profileQuery.update(updatedProfile)
    .then((response) => {
      const { data } = response;
      const { user } = data.updateUserProfile;
      dispatch('index/setUserInfo', user, { root: true });
    });
};

export const uploadMedia = ({ commit }, { file }) => mediaHelper.upload(file)
  .then((response) => {
    const { data } = response;
    commit(SET_USER_PHOTO, data.path);
  });

export const clearUserPhoto = ({ commit }) => {
  commit(CLEAR_USER_PHOTO);
};



// WEBPACK FOOTER //
// ./src/screens/Profile/store/actions.js